<template>
        <div class="col-md-4">
            <div class="card" style="height: 223.8px;">
                <div class="card-content">
                    <div class="card-body">
                        <small>
                            {{ $t('le_before_date')}}
                            {{note.created | formatLongDatetime}}
                        </small>
                        <h3 class="text-info mt-1">
                            <strong>{{note.subject}}</strong>
                        </h3>
                        <hr class="my-2">
                        <p class="card-text">{{note.content}}</p>
                    </div>
                </div>
            </div>
        </div>
</template>
<script>
export default {
  props: {
    note: Object
  }
}
</script>
